import { ErrorMessage, Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React from "react";
import { Button,  Divider,  Label } from "semantic-ui-react";
import * as Yup from 'yup';
import { _GetBonusText, _GetFilterName } from "../../app/lib/CommonFunctions";
import { MyCheckBoxField } from "../../app/lib/MyCheckBoxField";
import MyTextInputNonFluid from "../../app/lib/MyTextInputNonFluid";
import { WheelingCondition } from "../../app/models/IDayResult";
import { useStore } from "../../app/store/store";


export default observer(function FilterGap(){
    const {userStore, modalStore} = useStore();
    

    const validationSchema = Yup.object({
        gap: Yup.string().required("Gap is required !").test("checkInterval","Invalid Gap. Use - for range or coma for one Gap. Use ALL for all Gap ! ", (value, ctx) => {
            if (!value) return false;

            if (value === "ALL"){
                return true;
            }
            const allGaps = value!.split(',');
            let ok = true;    
            allGaps.map((y) => {
                const gap = y.split('-');

                if (gap.length > 2){
                    ok = false;
                    return false;
                }
                if (gap.length === 2){
                    const fromGap = Number(gap[0]);
                    const toGap = Number(gap[1]);

                    if (isNaN(fromGap) || isNaN(toGap)){
                        ok = false;
                        return false;
                    }

                    if(fromGap > toGap){
                        ok = false;
                        return false;
                    }
                    return true;
                }

                const gap1 = Number(y);


                if (isNaN(gap1)){
                    ok = false;
                    return false;
                }
                return true;
            })

            return ok;
        }),
        min: Yup.number().required("Minimum is required !").positive().integer().min(0,"Minimum cannot be smaller than 0 ").max(49,"Maximum cannot be greater than 12").test("checkGreater","Minimum must be smaller than Maximum !",(value, ctx)=> Number(ctx.parent.max) >= Number(value)),
        max: Yup.number().required("Maximum is required !").positive().integer().min(0,"Minimum cannot be smaller than 0 ").max(49,"Maximum cannot be greater than 12"),
    });

    return (
        <Formik initialValues={{ gap: "", min: 0, max: 3,  error: null}}
                onSubmit={
                    (values,{setErrors}) => {
                        const gap = values["gap"]
                        const minValue = values["min"];
                        const maxValue = values["max"];

                        var filterCondition: WheelingCondition = {
                            filterType : "14",
                            filterTypeName: _GetFilterName("14"),
                            data : gap,
                            min: Number(minValue),
                            max: Number(maxValue)
                        };

                        localStorage.setItem("FilterCondition", JSON.stringify(filterCondition));
                        modalStore.closeModal();
                    }
                } validationSchema={validationSchema}
        >
            {(
                {handleSubmit, isSubmitting, errors}) => (
                    <Form className="ui form" onSubmit={handleSubmit}>
                        <MyTextInputNonFluid data-tooltip="Gap to filter" name="gap" placeholder="Enter Gap separated by - or coma or ALL"></MyTextInputNonFluid>
                        <MyTextInputNonFluid data-tooltip="Minimum value to filter" type="number" name="min" placeholder="Enter Mininum"></MyTextInputNonFluid>
                        <MyTextInputNonFluid data-tooltip="Maximum value to filter" type="number" name="max" placeholder="Enter maximum"></MyTextInputNonFluid>


                        <ErrorMessage name="error" render={ ()=> <Label style={{marginBottom: 10}} basic color ="red" content={errors.error}></Label>}/>
                        <Divider />
                        <Button icon="save" loading={isSubmitting} positive content="Save" type="submit" fluid></Button>
                    </Form>
                
            )}
        </Formik>
    )
})